/**
 * @desc 暂存区列表分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stagingAreaMaster.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
